var _desc, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUndoLeftSquare(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-0.5 -0.5 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    id: "Undo-Left-Square--Streamline-Solar-Broken",
    height: 16,
    width: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Undo Left Square Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.0625 5.93735625h4.7115625c0.8548749999999999 0 1.2823125 0 1.592125 0.20029999999999998 0.1485 0.096025 0.275 0.22246875 0.371 0.37103125000000003 0.2003125 0.30974999999999997 0.2003125 0.73725 0.2003125 1.592125 0 0.8549374999999999 0 1.282375 -0.2003125 1.592125 -0.09599999999999999 0.1485625 -0.22249999999999998 0.275 -0.371 0.3710625 -0.3098125 0.2003125 -0.73725 0.2003125 -1.592125 0.2003125H5.9375m-1.875 -4.326956249999999 1.40625 -1.2980749999999999M4.0625 5.93735625l1.40625 1.29808125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 7.5c0 2.94625 0 4.4194375 -0.9153125 5.3346875C11.9194375 13.75 10.44625 13.75 7.5 13.75c-2.94628125 0 -4.41941875 0 -5.33470625 -0.9153125C1.25 11.9194375 1.25 10.44625 1.25 7.5c0 -2.94628125 0 -4.41941875 0.91529375 -5.33470625C3.0805812500000003 1.25 4.55371875 1.25 7.5 1.25c2.94625 0 4.4194375 0 5.3346875 0.91529375 0.608625 0.6085875000000001 0.8125625000000001 1.4638 0.880875 2.83470625",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUndoLeftSquare);
export default __webpack_public_path__ + "static/media/Undo-Left-Square.267991320e636c37f83efd0790a93d11.svg";
export { ForwardRef as ReactComponent };